import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_COMMISSION_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import getCommissionDetailsReport from './models/commissionDetailsReport'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const commissionDetailsReport = {
  namespaced: true,
  state: buildInitialState({
    ...getCommissionDetailsReport()
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearCommissionDetailsReport: (state) => {
      state.employeeName = null
      state.assignmentGrossProfitItems = []
      state.directPlacementGrossProfitItems = []
      state.commissionTiers = []
      state.consultantsGP = null
      state.permPlacementGP = null
      state.totalIndividualGP = null
      state.commissionOverridePercentage = null
      state.commissionOverride = null
      state.totalCommission = null
    },
    setCommissionDetailsReport: (state, commissionsDetailReport) => {
      state.employeeName = commissionsDetailReport.employeeName
      state.assignmentGrossProfitItems = commissionsDetailReport.assignmentGrossProfitItems
      state.directPlacementGrossProfitItems = commissionsDetailReport.directPlacementGrossProfitItems
      state.teamMembersGrossProfitItems = commissionsDetailReport.teamMembersGrossProfitItems
      state.commissionTiers = commissionsDetailReport.commissionTiers
      state.consultantsGP = commissionsDetailReport.consultantsGP
      state.permPlacementGP = commissionsDetailReport.permPlacementGP
      state.totalIndividualGP = commissionsDetailReport.totalIndividualGP
      state.commissionOverridePercentage = commissionsDetailReport.commissionOverridePercentage
      state.commissionOverride = commissionsDetailReport.commissionOverride
      state.totalCommission = commissionsDetailReport.totalCommission
    }
  },
  actions: {
    getCommissionDetailsReport: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting commission data, please wait...' })
      return api.doGet({ path: PATH_COMMISSION_REPORT, parameters: filters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          if (data && data.length > 0) {
            commit('setCommissionDetailsReport', data[0])
          } else {
            commit('clearCommissionDetailsReport')
          }
          hideProgressModal({ dispatch })
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get Commission Details Report')
        })
    },
    getCommissionDetailsReportWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getCommissionDetailsReport', { ...rootGetters['commissionDetailsReportFilters/getSearchObject'] })
    }
  }
}

export default commissionDetailsReport
